import { Injectable } from '@angular/core';
import { ICategoriesApiService } from './categories-api.interface';
import { Category } from '../../model/category';
import { CreateCategoryRequestDto } from './dtos/create-category.request.dto';
import { CreateCategoryResponseDto } from './dtos/create-category.response.dto';
import { UpdateCategoryRequestDto } from './dtos/update-category.request.dto';
import { UpdateCategoryResponseDto } from './dtos/update-category.response.dto';

@Injectable({
  providedIn: 'root',
})
export class CategoriesMockApiService implements ICategoriesApiService {
  async createCategory(
    category: CreateCategoryRequestDto,
  ): Promise<CreateCategoryResponseDto> {
    throw new Error('Method not implemented.');
  }

  async updateCategory(categoryId: number, category: UpdateCategoryRequestDto): Promise<UpdateCategoryResponseDto> {
    throw new Error('Method not implemented.');
  }


  async deleteCategory(categoryId: Category['id']): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
